/* This file is autogenerated, see readme.md for instructions */
import BrowserPushSvgIcon from '@bloomreach/banana-theme/icons/browser-push.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const BrowserPushIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <BrowserPushSvgIcon />
    </Icon>
  );
});

BrowserPushIcon.displayName = 'BrowserPushIcon';

export default BrowserPushIcon;
